<template>
  <div class="progress">
    <div class="progress-bar" :style="`width: ${percentage}%; background-color: ${color}`">
      <div v-if="showText" class="progress-text text-top">
        {{ progressText }}
      </div>
    </div>
    <div v-if="showText" class="progress-text text-bottom">
      {{ progressText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    progressText() {
      return `${Math.round(this.percentage)}%`
    },
  },
}
</script>

<style scoped lang="postcss">
.progress {
  @apply relative bg-gray-200 rounded;
}
.progress-bar {
  @apply absolute z-30 h-full rounded;
}
.progress-text {
  @apply text-xs pl-1 py-px font-bold;
}
.text-top {
  @apply text-white overflow-hidden;
}
.text-bottom {
  @apply absolute top-0 text-black;
}
</style>
